import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  addPermissionToRoleService,
  createRoleService,
  deleteRoleService,
  removePermissionFromRoleService,
} from '../services/roles.service';
import {
  TAddRolePermissionReqParams,
  TCreateRoleReqParams,
  TDeleteRoleReqParams, TRemoveRolePermissionReqParams,
  TRolesListResData,
} from '../types/roles.types';

export const useGetPermissionTableQuery = (
  counterpartyGUID: string,
  options?: any,
): UseQueryResult<TRolesListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.RbacQueryKeys].getPermissionTableData(counterpartyGUID),
    ...options,
  });

export const useGetCounterpartyScopesQuery = (
  counterpartyGUID: string,
  options?: any,
): UseQueryResult<TRolesListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.RbacQueryKeys].getCounterpartyScopesList(counterpartyGUID),
    ...options,
  });

export const useGetCounterpartyRoleListQuery = (
  counterpartyGUID: string,
  options?: any,
): UseQueryResult<TRolesListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.RbacQueryKeys].getCounterpartyRoleList(counterpartyGUID),
    ...options,
  });

export const useCreateRoleMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TCreateRoleReqParams }) =>
      createRoleService(data.counterpartyGUID, data.requestData),
  });

export const useDeleteRoleMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TDeleteRoleReqParams }) =>
      deleteRoleService(data.counterpartyGUID, data.requestData),
  });

export const useAddPermissionToRoleMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TAddRolePermissionReqParams }) =>
      addPermissionToRoleService(data.counterpartyGUID, data.requestData),
  });

export const useRemovePermissionFromRoleMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TRemoveRolePermissionReqParams }) =>
      removePermissionFromRoleService(data.counterpartyGUID, data.requestData),
  });
